import store from '@/store/index.js'
import { makeRequest } from '@/libs/RequestModule'

const getAutoRechargeDetails = async function () {
    const { CDCONSUMIDOR } = store.getters.getCurrDependent
    const response = await makeRequest('getAutoRechargeDetails', { CDCONSUMIDOR })
    const autoRechargeDetails = response?.data
    store.dispatch('setAutoRechargeList', autoRechargeDetails)
    return response
}

const confirmAutoRecharge = async function (minValue, rechargeValue, CDFAMILISALD) {
    const { CDCONSUMIDOR } = store.getters.getCurrDependent
    const response = (await makeRequest('confirmAutoRecharge', { CDCONSUMIDOR, minValue, rechargeValue, CDFAMILISALD }))?.data
    return response
}

export { getAutoRechargeDetails, confirmAutoRecharge }
